import { render, staticRenderFns } from "./groupMenuNav.vue?vue&type=template&id=5334c073"
import script from "./groupMenuNav.vue?vue&type=script&lang=js"
export * from "./groupMenuNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports